import { render, staticRenderFns } from "./NewPartyModal.vue?vue&type=template&id=30c758ba&"
import script from "./NewPartyModal.vue?vue&type=script&lang=ts&"
export * from "./NewPartyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports